import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../../layout/Layout";
import PageBanner from "../../layout/PageBanner";
import { catalogService } from "../../services";
import { SkeletonGrid } from "../../components/ui";

export default function MobileList() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    let alive = true;
    catalogService.mobileOperators().then((data) => alive && setRows(data || []));
    return () => {
      alive = false;
    };
  }, []);

  return (
    <Layout>
      <PageBanner title="เติมเงินมือถือ" breadcrumb={[{ label: "เติมเงินมือถือ" }]} seed={6} />

      <div className="lucid-container" style={{ marginTop: -30, position: "relative", zIndex: 3, paddingBottom: 40 }}>
        <div className="lt-panel">
          <div className="lt-panel__head">
            <span className="lt-step">1</span>
            <div>
              <h2 className="lt-panel__title">เลือกเครือข่ายที่ต้องการเติม</h2>
              <p className="lt-panel__subtitle">ยอดเงินเข้าอัตโนมัติภายใน 1-3 นาที</p>
            </div>
          </div>

          {rows === null ? (
            <SkeletonGrid count={4} height={190} />
          ) : (
            <div className="lt-tile-grid">
              {rows.map((item) => (
                <Link key={item.id} to={`/topup/mobile/${item.id}/${item.slug}`} className="lt-tile">
                  <div className="lt-tile__image">
                    <img src={item.image} alt={item.name} loading="lazy" />
                  </div>
                  <div className="lt-tile__name">{item.name}</div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
